import { createTheme } from '@mui/material/styles';
import '../styles/index.scss'

export const theme = createTheme({
  typography: {
    fontSize: 16,
    htmlFontSize: 16,
    fontFamily: [
      'Gotham',
      'Arial',
      'sans-serif',
    ].join(','),
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontFamily: '"Gotham", "Arial", sans-serif',
        },
        '@media (max-width: 600px)': {
          html: {
            fontSize: '0.8rem',
          },
        },
      },
    },
  },
});